import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "aria-label": "Page Paginator" }
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = {
  "data-test": "pageNumber",
  class: "page-item disabled"
}
const _hoisted_4 = { class: "page-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabled: _ctx.prevDisabled }]),
        "data-test": "prevBtn"
      }, [
        _createElementVNode("a", {
          class: "page-link cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrevHandler && _ctx.onPrevHandler(...args)))
        }, "Previous")
      ], 2),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentPage), 1)
      ]),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabled: _ctx.nextDisabled }]),
        "data-test": "nextBtn"
      }, [
        _createElementVNode("a", {
          class: "page-link cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNextHandler && _ctx.onNextHandler(...args)))
        }, " Next ")
      ], 2)
    ])
  ]))
}